import { TaskPriority } from "@fartherfinance/frontend/api/Tasks/Types";
import {
  mapTaskPriorityToLabel,
  mapTaskStatusToLabel,
} from "@fartherfinance/frontend/api/Tasks/utils/mappings";

import { TaskFormData } from "@src/multiCustodian/components/TaskForm/TaskFormV3";
import { EnhancedAutocompleteOption } from "@src/multiCustodian/pages/Advisor/common";
import {
  assigneeDefaultOption,
  TaskAssigneeAutocompleteOption,
} from "@src/multiCustodian/pages/Advisor/Tasks/common";

import { VirtualTask } from "./types";

export const mapVirtualTaskToFormData = (
  task: VirtualTask
): Partial<TaskFormData> => {
  return {
    title: task.title,
    description: task.description ?? "",
    dueDate: task.dueDate ?? null,
    taskPriority: {
      label: mapTaskPriorityToLabel(
        task.taskPriority ?? TaskPriority.enum.MEDIUM
      ),
      value: task.taskPriority ?? TaskPriority.enum.MEDIUM,
    },
    taskStatus: {
      label: mapTaskStatusToLabel(task.taskStatus),
      value: task.taskStatus,
    },
    taskType: task.taskType
      ? ({
          label: task.taskType,
          value: task.taskType,
        } as EnhancedAutocompleteOption<any>)
      : null,
    advisor: task.advisorId
      ? ({
          label: "",
          value: task.advisorId,
        } as EnhancedAutocompleteOption<string>)
      : null,
    assignee: task.assigneeId
      ? ({
          label: "",
          value: task.assigneeId,
          meta: { type: "PERSON" },
        } as TaskAssigneeAutocompleteOption)
      : assigneeDefaultOption,
    client: task.clientId
      ? ({
          label: "",
          value: task.clientId,
        } as EnhancedAutocompleteOption<string>)
      : null,
    serviceTeam: task.serviceTeamId
      ? ({
          label: "",
          value: task.serviceTeamId,
        } as EnhancedAutocompleteOption<string>)
      : null,
    custodian: task.custodian
      ? { label: task.custodian, value: task.custodian }
      : null,
  } as Partial<TaskFormData>;
};

export const mapFormDataToVirtualTask = (
  original: VirtualTask,
  data: TaskFormData
): VirtualTask => {
  return {
    ...original,
    title: data.title,
    description: data.description,
    dueDate: data.dueDate,
    taskPriority: data.taskPriority.value,
    taskStatus: data.taskStatus.value,
    taskType: data.taskType?.value ?? undefined,
    advisorId: data.advisor?.value ?? undefined,
    assigneeId: data.assignee?.value ?? undefined,
    clientId: data.client?.value ?? undefined,
    serviceTeamId: data.serviceTeam?.value ?? undefined,
    custodian: data.custodian?.value ?? undefined,
  };
};
